import { Modal, Button, Text, Icon } from '@msc-b2c/shared-components';
import styles from '../../PostBookingResultsWrapper.module.scss';

export function CannotBookPopUp({
  modalTitle,
  modalBodyText,
  modalButtonLabel,
  handleClose,
  handleClick,
}: Readonly<{
  modalTitle: string;
  modalBodyText: string;
  modalButtonLabel: string;
  handleClose: () => void;
  handleClick: () => void;
}>) {
  return (
    <Modal
      onClose={handleClose}
      styleOption={`-modal-private-area`}
      hideCloseIcon
    >
      <div className={styles['cannot-book-modal-header']}>
        <Text
          text={modalTitle}
          styleOption="cmp-text__big bold"
        />
        <Icon
          icon="close"
          onClick={handleClose}
          ariaLabel="Close"
        />
      </div>
      <div className="cmp-container__modal-body">
        <Text
          text={modalBodyText}
          styleOption="cmp-text__normal"
        />
      </div>
      <div className="cmp-container__modal-buttons">
        <Button
          text={modalButtonLabel}
          styleOption="cmp-button__primary"
          onClick={handleClick}
        />
      </div>
    </Modal>
  );
}
